import { Component, Vue } from "vue-property-decorator";

@Component<Loading>({
  components: {}
})
export default class Loading extends Vue {}
